let envList = {
  dev: 'dev',
  production: 'production',
};

let awsUrl = {
  dev: 'wss://82q6nuplv0.execute-api.ap-northeast-1.amazonaws.com/dev',
  production: 'wss://82q6nuplv0.execute-api.ap-northeast-1.amazonaws.com/production',
};

let stripKey = {
  test: 'pk_test_lXQvIVyg33i6wCEagbMGIICd',
  biz: 'pk_live_SAO5zmCNp1HfQxRkvfLU7YwS',
};

/* 注释掉下面的这行， 切换到 生产环境 */
// let env = envList.dev;
// 切换
let env = envList.production;

const getConfigAwsUrl = () => {
  return env === envList.dev ? awsUrl.dev : awsUrl.production;
};

const getConfigStripKey = () => {
  return env === envList.dev ? stripKey.test : stripKey.biz;
};

export const envConfig = {
  getConfigAwsUrl,
  getConfigAppApiUrl: () => `https://app.candyhouse.co/${env === envList.dev ? 'dev' : 'prod'}`,
  getConfigStripKey,
};
